import { ReactElement, useRef, useState } from 'react';
import '../styles/triple-oaks.css';
import blip1 from "url:../assets/blip-1.gif";
import blip2 from "url:../assets/blip-2.png";
import blip3 from "url:../assets/blip-3.png";
import blip4 from "url:../assets/blip-4.png";
import blip5 from "url:../assets/blip-5.png";

export function Blips(props: {onSuccess : any}) {
    const [code, setCode] = useState('');

    const updateCode = (s : string) => {
        if (s == '1143')
        {
            props.onSuccess();
            setCode('');
        }
        else
            setCode(s);
    }

    return (
        <div className='trok-blips'>
            <button className='trok-blip' onClick={() => { updateCode(code + '1'); }}><img src={blip1} /></button>
            <button className='trok-blip' onClick={() => { updateCode(code + '2'); }}><img src={blip2} /></button>
            <button className='trok-blip' onClick={() => { updateCode(code + '3'); }}><img src={blip3} /></button>
            <button className='trok-blip' onClick={() => { updateCode(code + '4'); }}><img src={blip5} /></button>
            <button className='trok-blip' onClick={() => { setCode(''); }}><img src={blip4} /></button>
        </div>
    );
}

export function Blipset(props: { pass: string, elements: ReactElement[], clear: ReactElement, onSuccess: any })
{
    const [code, setCode] = useState('');

    const updateCode = (s : string) => {
        if (s == props.pass)
        {
            props.onSuccess();
            setCode('');
        }
        else
            setCode(s);
    }

    const buttons = props.elements.map((e, i) => {
        return <button key={i} onClick={() => { updateCode(code + (i + 1)); }}>{e}</button>
    });

    return (
        <div className='trok-blips'>
            { buttons }
            { props.clear }
        </div>
    );
}